import * as React from 'react'
import { Defs, LinearGradient, Path, Stop } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { svgIdentifier } from 'ui/svg/utils'

import { AccessibleIcon } from './types'

const NewIconSvg: React.FunctionComponent<AccessibleIcon> = ({
  size,
  color,
  color2,
  accessibilityLabel,
  testID,
}) => {
  const { id: gradientId, fill: gradientFill } = svgIdentifier()
  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.495 10.6316L15.3816 3.74672L17.1759 5.10707L19.4921 10.6316L19.4929 10.6335C19.7799 11.3122 20.417 11.7898 21.1635 11.8517L21.1659 11.8519L22.535 11.9726C22.9018 12.0049 23.2253 11.7337 23.2577 11.3669C23.29 11.0001 23.0188 10.6765 22.6521 10.6442L21.2787 10.5232L21.2745 10.5228C21.0357 10.5033 20.8207 10.3494 20.7212 10.1148L20.7209 10.1141L19.2954 6.71402L26.0424 11.8294C26.1125 12.093 26.3413 12.2971 26.6288 12.3223L26.7009 12.3286L28.72 13.8594L23.3282 18.5723L23.3258 18.5744C22.7733 19.062 22.5206 19.8145 22.6909 20.5433L22.6911 20.5442L24.3706 27.824C24.5085 28.4222 23.8678 28.8598 23.3798 28.5633L17.0332 24.7039L17.0294 24.7016C16.3918 24.3198 15.6019 24.3198 14.9644 24.7016L14.9605 24.7039L8.61388 28.5634C8.12426 28.8609 7.48553 28.4263 7.62336 27.8231L9.30267 20.5442L9.30293 20.5431C9.47206 19.8188 9.2241 19.0561 8.66431 18.5712L8.66284 18.5699L3.06531 13.6771C2.6108 13.2803 2.86268 12.5404 3.44437 12.4904L10.8212 11.8519L10.8229 11.8518C11.5697 11.7901 12.2072 11.3124 12.4942 10.6335L12.495 10.6316ZM28.7205 13.8589L28.72 13.8594L29.805 14.682L24.208 19.5743L24.2068 19.5754C24.0138 19.7465 23.9335 20.0016 23.9893 20.2402L23.9898 20.2423L25.6698 27.5242C26.0652 29.2389 24.2126 30.63 22.6873 29.7029L16.3444 25.8458L16.3428 25.8448C16.1278 25.7168 15.866 25.7168 15.651 25.8448L15.6494 25.8458L9.30657 29.7029C7.78302 30.6289 5.92879 29.2479 6.32375 27.5251L8.00396 20.2423L8.00445 20.2402C8.06132 19.9973 7.9765 19.7392 7.79094 19.5788L7.78818 19.5764L2.18847 14.6818C0.856798 13.5187 1.56485 11.3138 3.32941 11.1618L10.7094 10.5231L10.7126 10.5228C10.9514 10.5033 11.1664 10.3494 11.2659 10.1148L11.2662 10.1141L14.1521 3.23079C14.8389 1.59438 17.1527 1.58461 17.8356 3.23227L17.8363 3.23374L19.2952 6.71365L17.1758 5.1069L16.6054 3.74648L16.6042 3.74353C16.3797 3.2008 15.6147 3.1919 15.3816 3.74672L17.1758 5.1069L17.1759 5.10707L19.2954 6.71402L19.2952 6.71365L26.0422 11.8285C26.0423 11.8288 26.0423 11.8291 26.0424 11.8294L26.7009 12.3286L26.702 12.3287L28.7205 13.8589ZM28.7205 13.8589L28.9288 13.6769C29.3793 13.2839 29.1272 12.5401 28.5498 12.4904L26.702 12.3287L26.0422 11.8285C26.023 11.756 26.0158 11.6789 26.0228 11.5999C26.0549 11.233 26.3782 10.9617 26.745 10.9938L28.664 11.1618C30.4326 11.3143 31.1274 13.5279 29.8056 14.6815L28.7205 13.8589ZM4.47157 3.51788C4.21122 3.25749 3.78911 3.25749 3.52876 3.51788C3.26841 3.77828 3.26841 4.20046 3.52876 4.46085L6.86209 7.79472C7.12244 8.05511 7.54455 8.05511 7.8049 7.79472C8.06525 7.53433 8.06525 7.11215 7.8049 6.85176L4.47157 3.51788ZM28.4716 4.46085C28.7319 4.20046 28.7319 3.77828 28.4716 3.51788C28.2112 3.25749 27.7891 3.25749 27.5288 3.51788L24.1954 6.85176C23.9351 7.11215 23.9351 7.53433 24.1954 7.79472C24.4558 8.05511 24.8779 8.05511 25.1382 7.79472L28.4716 4.46085ZM27.8049 21.5208C27.5445 21.2604 27.1224 21.2604 26.8621 21.5208C26.6017 21.7812 26.6017 22.2034 26.8621 22.4638L29.5288 25.1309C29.7891 25.3913 30.2112 25.3913 30.4716 25.1309C30.7319 24.8705 30.7319 24.4483 30.4716 24.1879L27.8049 21.5208ZM5.13823 23.1305C5.39858 22.8701 5.39858 22.448 5.13823 22.1876C4.87788 21.9272 4.45577 21.9272 4.19542 22.1876L1.52876 24.8547C1.26841 25.1151 1.26841 25.5372 1.52876 25.7976C1.78911 26.058 2.21122 26.058 2.47157 25.7976L5.13823 23.1305Z"
        fill={gradientFill}
      />
      <Defs>
        <LinearGradient
          id={gradientId}
          x1="1.3335"
          y1="2"
          x2="11.4609"
          y2="31.5205"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor={color} />
          <Stop offset="1" stopColor={color2} />
        </LinearGradient>
      </Defs>
    </AccessibleSvg>
  )
}

export const NewIcon = styled(NewIconSvg).attrs(
  ({ theme, color = theme.colors.black, size = theme.icons.sizes.standard }) => ({
    color,
    size,
  })
)``

export const BicolorNewIcon = styled(NewIconSvg).attrs(
  ({
    theme,
    color = theme.colors.primary,
    color2 = theme.colors.secondary,
    size = theme.icons.sizes.standard,
  }) => ({
    color,
    color2,
    size,
  })
)``
